import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuditLogService from "services/AuditLogService";

export const initialState = {
  list: [],
  loading: false,
  errorMessages: [],
};

export const getAuditLog = createAsyncThunk(
  "/getAuditLog",
  async (searchParams, { rejectWithValue }) => {
    try {
      const response = await AuditLogService.getAuditLog(searchParams);
      const code = response.code;
      return {
        code: code,
        logs: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error fetching audit logs",
        }
      );
    }
  }
);

export const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLog.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAuditLog.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.logs;
      })
      .addCase(getAuditLog.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = auditLogSlice.actions;

export default auditLogSlice.reducer;
